import styled, { AnyStyledComponent } from "styled-components";
import COLORS from "../../../style/universal.color";
import { NewsletterOptinMessageIcons } from "../newsletterOptin.types";
import { NewsletterOptinStyleProps } from "../newsletterOptin.types";

const {
  stripesRed,
  ticketGreen,
} = COLORS;

const getIconBgColor = ({ messageIcon }: NewsletterOptinStyleProps):string => {
  const iconMessageMap = {
    [NewsletterOptinMessageIcons.ERROR]: `${stripesRed}`,
    [NewsletterOptinMessageIcons.CHECK]: `${ticketGreen}`
  };

  return messageIcon && iconMessageMap[messageIcon] || 'transparent';
};

export const IconContainer: AnyStyledComponent = styled.span`
  background-color: ${getIconBgColor};
  border-radius: 10px;
  height: 20px;
  left: 0;
  position: absolute;
  top: 0;
  width: 20px;

  svg {
    position: relative;
    top: 1px;
  }
`;
